<div class="map-container mat-mdc-card-outlined" [ngClass]="{ 'active-map': isMapSelected }" (click)="onMapContainerSelected()">
    <p *ngIf="upperLabel" class="upper-label">
        {{ upperLabel }}
    </p>
    <div class="vista-container" cardioMap #svgElContainer [ngStyle]="wrapperDimensions">
        <svg
            anatomicMapDirective
            width="100%"
            height="100%"
            [attr.id]="map?.viewId || 'map'"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 500 500"
            font-size="24px"
        >
            <rect [attr.fill]="boardFill" width="100%" height="100%"></rect>
            <text *ngIf="!map" x="200" y="250" stroke="black" fill="black">No Map Loaded</text>
            <image *ngIf="map && map.pathImg" [attr.href]="map.pathImg" height="100%" width="100%"  onload="this.style.display='initial'" onerror="this.style.display='none'"/>
        </svg>
    </div>
    <p *ngIf="lowerLabel" class="lower-label">{{ lowerLabel }}</p>
    <p *ngIf="isWithViewId && map?.viewId" class="map-id-label">{{'ViewLabel' | translate}}: {{ map?.viewId }}</p>
    <p *ngIf="isWithStageName && map?.stageDescription" class="map-id-label">{{'StageLabel' | translate}}: {{ map?.stageDescription }}</p>
</div>
